import { format } from 'date-fns'
import { injectIntl, WrappedComponentProps } from 'react-intl'

import { FULL_DATE } from '@constants'
import { PublishOptions } from '@enums'
import { IOption } from '@store/rootResource'
import { Select } from '@tribegroup'

interface IPublishingOptionsProps {
  // tslint:disable-next-line:readonly-array
  options: any[]
  placeholder: string
  selectedDate?: Date
  hasChosenDateOption: boolean
  onChangeOption: (option: IOption) => void
  selectedOption?: any
}

interface IInternalProps extends IPublishingOptionsProps, WrappedComponentProps {}

export const PublishingOptions = ({
  selectedOption,
  hasChosenDateOption,
  selectedDate,
  placeholder,
  options,
  onChangeOption,
  intl,
}: IInternalProps) => {
  const hasDate = hasChosenDateOption && Boolean(selectedDate)
  let label = hasDate
    ? intl.formatMessage(
        { id: 'socialSubmission.card.modal.approve.onDate' },
        { date: format(selectedDate!, FULL_DATE) },
      )
    : undefined

  if (selectedOption === PublishOptions.WITHIN_48_HOURS) {
    label = intl.formatMessage({
      id: 'socialSubmission.card.modal.approve.within48Hours',
    })
  }

  return (
    <Select
      scheme="primary"
      quiet
      large
      underlined
      label={label}
      rsConfig={{
        isSearchable: false,
        placeholder,
        options,
        onChange: onChangeOption,
        name: 'publishing-options',
        inputId: 'publishing-options',
      }}
    />
  )
}

export default injectIntl(PublishingOptions)
